import { toList3jhuyej2anx2q as toList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { remembery2gxxk5pa2qe as remember } from '../core/Remember.mjs';
import {
  awaitOnce2ui7qqi9bvdeq as awaitOnce,
  await1kke5zj2piplv as await_0,
} from '../context/DependencyChangeListener.mjs';
import {
  _ReactiveState___get_raw__impl__92ipya10f5f3x6hwqt0 as _ReactiveState___get_raw__impl__92ipya,
  InternalReactiveNotReadygki7zhqkkp9u as InternalReactiveNotReady,
  InternalReactiveThrownException1wn4fe03qbefg as InternalReactiveThrownException,
  InternalReactiveWrapper6qytbrc1rcqv as InternalReactiveWrapper,
  InternalReactiveNotReady_instance37iasaqvolrrz as InternalReactiveNotReady_instance,
} from '../core/ReactiveState.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import {
  Companion_getInstancec4l82qvpwbuq as Companion_getInstance,
  lens2x0usmj7eco4 as lens,
  lens2po2j99uxhjgr as lens_0,
  MutableReactive2qdhhyljdknhy as MutableReactive,
  Reactive1jy75v4li6ldv as Reactive,
} from '../core/coreInterfaces.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { onRemove3k528udkni1ni as onRemove } from '../context/CalculationContext.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function withWrite(_this__u8e3s4, action) {
  return new (withWrite$1())(_this__u8e3s4, action);
}
function invokeAllSafeMutable(_this__u8e3s4) {
  return invokeAllSafe(toList(_this__u8e3s4));
}
function invoke(_this__u8e3s4, $completion) {
  return awaitOnce(remember(VOID, VOID, VOID, ($this$remember) => {
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    return _this__u8e3s4($this$remember);
  }), $completion);
}
function set_value(_this__u8e3s4, value) {
  _this__u8e3s4.cak(value);
}
function onNextSuccess(_this__u8e3s4, action) {
  // Inline function 'com.lightningkite.reactive.core.ReactiveState.success' call
  var this_0 = _this__u8e3s4.qah();
  var tmp;
  // Inline function 'com.lightningkite.reactive.core.ReactiveState.ready' call
  var tmp_0 = _ReactiveState___get_raw__impl__92ipya(this_0);
  if (!(tmp_0 instanceof InternalReactiveNotReady())) {
    var tmp_1 = _ReactiveState___get_raw__impl__92ipya(this_0);
    tmp = !(tmp_1 instanceof InternalReactiveThrownException());
  } else {
    tmp = false;
  }
  if (tmp) {
    // Inline function 'com.lightningkite.reactive.core.ReactiveState.onSuccess' call
    // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
    var this_1 = _this__u8e3s4.qah();
    var tmp0_subject = _ReactiveState___get_raw__impl__92ipya(this_1);
    var tmp_2;
    if (equals(tmp0_subject, InternalReactiveNotReady_instance)) {
      tmp_2 = null;
    } else {
      if (tmp0_subject instanceof InternalReactiveThrownException()) {
        _ReactiveState___get_raw__impl__92ipya(this_1).sah_1;
        tmp_2 = null;
      } else {
        if (tmp0_subject instanceof InternalReactiveWrapper()) {
          var tmp_3 = _ReactiveState___get_raw__impl__92ipya(this_1).rah_1;
          tmp_2 = action((tmp_3 == null ? true : !(tmp_3 == null)) ? tmp_3 : THROW_CCE());
        } else {
          tmp_2 = action(_ReactiveState___get_raw__impl__92ipya(this_1));
        }
      }
    }
    return null;
  }
  var remover = {_v: null};
  remover._v = _this__u8e3s4.tah(() => {
    // Inline function 'com.lightningkite.reactive.core.ReactiveState.onSuccess' call
    // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
    var this_0 = _this__u8e3s4.qah();
    var tmp0_subject = _ReactiveState___get_raw__impl__92ipya(this_0);
    var tmp;
    if (equals(tmp0_subject, InternalReactiveNotReady_instance)) {
      tmp = null;
    } else {
      if (tmp0_subject instanceof InternalReactiveThrownException()) {
        _ReactiveState___get_raw__impl__92ipya(this_0).sah_1;
        tmp = null;
      } else {
        if (tmp0_subject instanceof InternalReactiveWrapper()) {
          var tmp_0 = _ReactiveState___get_raw__impl__92ipya(this_0).rah_1;
          var it = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
          action(it);
          var tmp0_safe_receiver = remover._v;
          tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver();
        } else {
          var it_0 = _ReactiveState___get_raw__impl__92ipya(this_0);
          action(it_0);
          var tmp0_safe_receiver_0 = remover._v;
          tmp = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0();
        }
      }
    }
    return Unit_instance;
  });
  return remover._v;
}
function interceptWrite(_this__u8e3s4, action) {
  return new (interceptWrite$1())(_this__u8e3s4, action);
}
function *_generator_modify__nczk7i(_this__u8e3s4, action, $completion) {
  var tmp = await_0(_this__u8e3s4, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = action(tmp, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = _this__u8e3s4.gah(tmp_0, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return Unit_instance;
}
function modify(_this__u8e3s4, action, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_modify__nczk7i.bind(VOID, _this__u8e3s4, action), $completion);
}
function *_generator_toggle__fwucek(_this__u8e3s4, $completion) {
  var tmp = awaitOnce(_this__u8e3s4, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = _this__u8e3s4.gah(!tmp, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
function toggle(_this__u8e3s4, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_toggle__fwucek.bind(VOID, _this__u8e3s4), $completion);
}
function toggle_0(_this__u8e3s4) {
  _this__u8e3s4.mam(!_this__u8e3s4.f2());
}
function *_generator_modify__nczk7i_0(_this__u8e3s4, action, $completion) {
  var tmp = action(_this__u8e3s4.f2(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  _this__u8e3s4.mam(tmp);
  return Unit_instance;
}
function modify_0(_this__u8e3s4, action, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_modify__nczk7i_0.bind(VOID, _this__u8e3s4, action), $completion);
}
function invokeAllSafe(_this__u8e3s4) {
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = _this__u8e3s4.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    $l$block: {
      try {
        element();
      } catch ($p) {
        if ($p instanceof Exception()) {
          var e = $p;
          if (e instanceof CancellationException()) {
            break $l$block;
          }
          Companion_getInstance().xaj_1(e);
        } else {
          throw $p;
        }
      }
    }
  }
  return Unit_instance;
}
function flatten(_this__u8e3s4) {
  var tmp = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.baj($this$remember.baj(_this__u8e3s4)));
  return withWrite(tmp, flatten$slambda_0(_this__u8e3s4));
}
function use(_this__u8e3s4, resourceUse) {
  var x = resourceUse.iaj();
  onRemove(_this__u8e3s4, () => {
    x();
    return Unit_instance;
  });
}
function nullable(_this__u8e3s4) {
  return new (nullable$1())(_this__u8e3s4);
}
function flatten_0(_this__u8e3s4) {
  return remember(VOID, VOID, VOID, ($this$remember) => $this$remember.baj($this$remember.baj(_this__u8e3s4)));
}
function *_generator_set__cb7isu($this, value, $completion) {
  var tmp = $this.mar_1($this.lar_1, value, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var withWrite$1Class;
function withWrite$1() {
  if (withWrite$1Class === VOID) {
    class $ {
      constructor($this_withWrite, $action) {
        this.lar_1 = $this_withWrite;
        this.mar_1 = $action;
        this.kar_1 = $this_withWrite;
      }
      gah(value, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_set__cb7isu.bind(VOID, this, value), $completion);
      }
      qah() {
        return this.kar_1.qah();
      }
      tah(listener) {
        return this.kar_1.tah(listener);
      }
      iaj() {
        return this.kar_1.iaj();
      }
    }
    protoOf($).tak = lens;
    protoOf($).bak = lens_0;
    initMetadataForClass($, VOID, VOID, VOID, [MutableReactive(), Reactive()], [1]);
    withWrite$1Class = $;
  }
  return withWrite$1Class;
}
function *_generator_set__cb7isu_0($this, value, $completion) {
  var tmp = $this.par_1($this.oar_1, value, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var interceptWrite$1Class;
function interceptWrite$1() {
  if (interceptWrite$1Class === VOID) {
    class $ {
      constructor($this_interceptWrite, $action) {
        this.oar_1 = $this_interceptWrite;
        this.par_1 = $action;
        this.nar_1 = $this_interceptWrite;
      }
      gah(value, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_set__cb7isu_0.bind(VOID, this, value), $completion);
      }
      qah() {
        return this.nar_1.qah();
      }
      tah(listener) {
        return this.nar_1.tah(listener);
      }
      iaj() {
        return this.nar_1.iaj();
      }
    }
    protoOf($).tak = lens;
    protoOf($).bak = lens_0;
    initMetadataForClass($, VOID, VOID, VOID, [MutableReactive(), Reactive()], [1]);
    interceptWrite$1Class = $;
  }
  return interceptWrite$1Class;
}
function *_generator_invoke__zhh2q8($this, $this$withWrite, it, $completion) {
  // Inline function 'com.lightningkite.reactive.core.ReactiveState.onSuccess' call
  // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
  var this_0 = $this.qar_1.qah();
  var tmp0_subject = _ReactiveState___get_raw__impl__92ipya(this_0);
  var tmp;
  if (equals(tmp0_subject, InternalReactiveNotReady_instance)) {
    tmp = null;
  } else {
    if (tmp0_subject instanceof InternalReactiveThrownException()) {
      _ReactiveState___get_raw__impl__92ipya(this_0).sah_1;
      tmp = null;
    } else {
      if (tmp0_subject instanceof InternalReactiveWrapper()) {
        var tmp_0 = _ReactiveState___get_raw__impl__92ipya(this_0).rah_1;
        var tmp_1 = ((tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE()).gah(it, $completion);
        if (tmp_1 === get_COROUTINE_SUSPENDED())
          tmp_1 = yield tmp_1;
        tmp = Unit_instance;
      } else {
        var tmp_2 = _ReactiveState___get_raw__impl__92ipya(this_0).gah(it, $completion);
        if (tmp_2 === get_COROUTINE_SUSPENDED())
          tmp_2 = yield tmp_2;
        tmp = Unit_instance;
      }
    }
  }
  return Unit_instance;
}
var flatten$slambdaClass;
function flatten$slambda() {
  if (flatten$slambdaClass === VOID) {
    class $ {
      constructor($this_flatten) {
        this.qar_1 = $this_flatten;
      }
      rar($this$withWrite, it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$withWrite, it), $completion);
      }
      rd(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, Reactive()) : false) ? p1 : THROW_CCE();
        return this.rar(tmp, (p2 == null ? true : !(p2 == null)) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    flatten$slambdaClass = $;
  }
  return flatten$slambdaClass;
}
function flatten$slambda_0($this_flatten) {
  var i = new (flatten$slambda())($this_flatten);
  var l = ($this$withWrite, it, $completion) => i.rar($this$withWrite, it, $completion);
  l.$arity = 2;
  return l;
}
function *_generator_set__cb7isu_1($this, value, $completion) {
  if (!(value == null)) {
    var tmp = $this.tar_1.gah(value, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  return Unit_instance;
}
var nullable$1Class;
function nullable$1() {
  if (nullable$1Class === VOID) {
    class $ {
      constructor($this_nullable) {
        this.tar_1 = $this_nullable;
        this.sar_1 = $this_nullable;
      }
      uar(value, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_set__cb7isu_1.bind(VOID, this, value), $completion);
      }
      gah(value, $completion) {
        return this.uar((value == null ? true : !(value == null)) ? value : THROW_CCE(), $completion);
      }
      var() {
        return this.sar_1.qah();
      }
      qah() {
        return this.var();
      }
      tah(listener) {
        return this.sar_1.tah(listener);
      }
      iaj() {
        return this.sar_1.iaj();
      }
    }
    protoOf($).tak = lens;
    protoOf($).bak = lens_0;
    initMetadataForClass($, VOID, VOID, VOID, [MutableReactive(), Reactive()], [1]);
    nullable$1Class = $;
  }
  return nullable$1Class;
}
//region block: exports
export {
  flatten_0 as flatten3gnxaa49k1jva,
  flatten as flattenml92kmikh8fo,
  interceptWrite as interceptWrite2xi6g5kl52xuu,
  invokeAllSafe as invokeAllSafe19fa1obs302ra,
  invokeAllSafeMutable as invokeAllSafeMutable13vuy5ase10ma,
  nullable as nullable1jpwknw8t4llm,
  onNextSuccess as onNextSuccessppx6mg1nws5i,
  toggle_0 as toggle2o6h9frvgo8sq,
  use as use25wcggkyjf1ad,
  set_value as set_value1vvx5pkb20ebv,
  withWrite as withWritedlio9p0oewet,
  invoke as invoke1ju2p3vzzanvk,
  modify as modify2eca96i8s7hc2,
  modify_0 as modify3tvoxz8jo60p8,
  toggle as toggle1hhzkiumllyqn,
};
//endregion

//# sourceMappingURL=helpers.mjs.map
